import { createSelector } from 'reselect';
import getAllBackgrounds from './getAllBackgrounds';

const isMultiBackground = createSelector([getAllBackgrounds], (backgrounds) => backgrounds.length > 1);

export default isMultiBackground;
